import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["marker"];

  declare readonly markerTargets: HTMLElement[];

  private frame: number | null = null;

  connect() {
    window.addEventListener("scroll", this.scheduleUpdate, { passive: true });
    window.addEventListener("resize", this.scheduleUpdate);
    this.update();
  }

  disconnect() {
    window.removeEventListener("scroll", this.scheduleUpdate);
    window.removeEventListener("resize", this.scheduleUpdate);

    if (this.frame !== null) cancelAnimationFrame(this.frame);
  }

  private scheduleUpdate = () => {
    if (this.frame !== null) return;

    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.update();
    });
  };

  private update() {
    let activeMarker: HTMLElement | undefined;

    this.markerTargets.forEach((marker) => {
      const markerRect = marker.getBoundingClientRect();
      const sectionRect = marker.closest("section")?.getBoundingClientRect();

      if (markerRect.top <= 1 && sectionRect && sectionRect.bottom > markerRect.height) {
        activeMarker = marker;
      }
    });

    this.markerTargets.forEach((marker) => {
      marker.classList.toggle("is-active", marker === activeMarker);
    });
  }
}
